import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _ctx.Client === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.getShowTask,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.getShowTask = $event),
    width: "20%",
    "align-center": "",
    style: {
      "border-radius": "10px",
      "overflow": "hidden",
      "min-width": "320px"
    },
    "before-close": _ctx.handleClose
  }, {
    default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "center"
      }
    }, [_createElementVNode("div", {
      style: {
        "border": "1px solid #13A4BF",
        "padding": "10px",
        "border-radius": "10px",
        "margin-bottom": "20px"
      }
    }, [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/code2.png",
      alt: "",
      style: {
        "width": "200px"
      }
    })]), _createElementVNode("span", null, "扫一扫，添加客服了解更多")], -1)])),
    _: 1,
    __: [2]
  }, 8, ["modelValue", "before-close"])])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_dialog, {
    class: "mobile-dialog",
    modelValue: _ctx.getShowTask,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.getShowTask = $event),
    width: "60%",
    "align-center": "",
    style: {
      "border-radius": "10px",
      "overflow": "hidden"
    },
    "before-close": _ctx.handleClose
  }, {
    default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "center",
        "margin-bottom": "30px"
      }
    }, [_createElementVNode("div", {
      style: {
        "border": "1px solid #13A4BF",
        "padding": "10px",
        "border-radius": "10px",
        "margin-bottom": "20px"
      }
    }, [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/code2.png",
      alt: "",
      style: {
        "width": "100%"
      }
    })]), _createElementVNode("span", {
      style: {
        "font-size": "2rem"
      }
    }, "扫一扫，添加客服了解更多")], -1)])),
    _: 1,
    __: [3]
  }, 8, ["modelValue", "before-close"])]));
}